import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Measure} from '../models/measure.model'

@Injectable({
    providedIn: 'root'
})
export class MeasureService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) {
        this.apiServer = this._configService.appSettings.webApiServer + "api/Measure/";
    }

    async setMeasure(measure: Measure): Promise<Measure> {
        return await this._http.post<Measure>(`${this.apiServer}SetMeasure`,JSON.stringify(measure)).toPromise<Measure>();
    }

    async getMeasure(id: number): Promise<Measure> {
        const params = new HttpParams()
            .set('id', id.toString());

        return await this._http.get<Measure>(`${this.apiServer}GetMeasure`, { params: params }).toPromise<Measure>();
    }

    async GetMeasureByFactor(measure: string): Promise<Measure> {
        const params = new HttpParams()
            .set('factor', measure);

        return await this._http.get<Measure>(`${this.apiServer}GetMeasureByFactor`, { params : params }).toPromise<Measure>();
    }

    async deleteMeasure( Id: number): Promise<number> {
        const params = new HttpParams()
            .set('id', Id.toString());
        return await this._http.delete<number>(`${this.apiServer}DeleteMeasure`,{params: params}).toPromise<number>();
    }

    async getMeasures(): Promise<Measure[]> {
        return await this._http.get<Measure[]>(`${this.apiServer}GetMeasures`).toPromise<Measure[]>();
    }

    async getMeasuresInfiniteScroll(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<Measure[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<Measure[]>(`${this.apiServer}GetMeasuresInfiniteScroll`, { params: params }).toPromise<Measure[]>();
    }

    async getCostCentersByMeasureId(id: number): Promise<string[]> {
        const params = new HttpParams()
            .set('Id', id.toString());
            return await this._http.get<string[]>(`${this.apiServer}GetCostCentersByMeasureId`, { params: params }).toPromise<string[]>();
    }
}
